export default {
    "text": {
        "VIEW_CHANNEL": { value: 1n << 0n, title: "View Channel", description: "Allows viewing a channel" },
        "MANAGE_MESSAGES": { value: 1n << 1n, title: "Manage Messages", description: "Allows managing messages" },
        "SEND_MESSAGES": { value: 1n << 2n, title: "Send Messages", description: "Allows sending messages" },
        "USE_EXTERNAL_EMOJIS": { value: 1n << 3n, title: "Use External Emojis", description: "Allows using external emojis" },
        "MANAGE_CHANNEL": { value: 1n << 4n, title: "Manage Channel", description: "Allows managing the channel" },
    },
    "voice": {
        "VIEW_CHANNEL": { value: 1n << 0n, title: "View Channel", description: "Allows viewing a channel" },
        /*"CONNECT": { value: 1n << 1n, title: "Connect", description: "Allows connecting to a voice channel" },
        "SPEAK": { value: 1n << 2n, title: "Speak", description: "Allows speaking in a voice channel" },
        "MUTE_MEMBERS": { value: 1n << 3n, title: "Mute Members", description: "Allows muting members" },
        "DEAFEN_MEMBERS": { value: 1n << 4n, title: "Deafen Members", description: "Allows deafening members" },
        "MOVE_MEMBERS": { value: 1n << 5n, title: "Move Members", description: "Allows moving members between channels" },*/
        "MANAGE_CHANNEL": { value: 1n << 6n, title: "Manage Channel", description: "Allows managing the channel" },
    },
    "todo": {
        "VIEW_CHANNEL": { value: 1n << 0n, title: "View Channel", description: "Allows viewing a channel" },
        //"MANAGE_TODOS": { value: 1n << 1n, title: "Manage Todos", description: "Allows managing todos" },
        "CREATE_TODOS": { value: 1n << 2n, title: "Create Todos", description: "Allows creating todos" },
        "DELETE_TODOS": { value: 1n << 3n, title: "Delete Todos", description: "Allows deleting todos" },
        "EDIT_TODOS": { value: 1n << 4n, title: "Edit Todos", description: "Allows editing todos" },
        "MANAGE_CHANNEL": { value: 1n << 5n, title: "Manage Channel", description: "Allows managing the channel" },
    },
    "watchstream": {
        "VIEW_CHANNEL": { value: 1n << 0n, title: "View Channel", description: "Allows viewing a channel" },
        "MANAGE_CHANNEL": { value: 1n << 1n, title: "Manage Channel", description: "Allows managing the channel" },
    },
    "defaults": {
        "text": 1n << 0n | 1n << 2n | 1n << 3n,
        "voice": 1n << 0n | 1n << 1n | 1n << 2n,
        "todo": 1n << 0n,
        "watchstream": 1n << 0n,
    }
}